import { ReactNode } from 'react'

import { Flex } from '@/components/ui/flex'
import { Tooltip } from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'

import * as S from './block-card.styled'

interface BlockCardProps {
  title: string
  tooltip: ReactNode
  children: ReactNode
  // The parent widget is off - grays out the whole section and blocks the cursor, instead of
  // relying on each row to show it individually.
  locked?: boolean
}

// No background/shadow of its own - all sections share one outer Card (home-screen.page.tsx).
export const BlockCard = ({ title, tooltip, children, locked }: BlockCardProps) => (
  <S.Section $locked={locked}>
    <Flex align="center" gap={8}>
      <Typography size="text-medium" weight="semibold">
        {title}
      </Typography>
      <Tooltip>{tooltip}</Tooltip>
    </Flex>
    {children}
  </S.Section>
)
